import { createFileRoute } from "@tanstack/react-router"
import { WandSparkles } from "lucide-react"

import { PageIntroSplitHeader } from "@/components/layout/page-intro-split-header"
import { SectionKicker } from "@/components/shared/section-kicker"
import { ThemeBuilderPage } from "@/components/shared/theme-builder-page"
import { Card } from "@/components/ui/card"

export const Route = createFileRoute("/_authed/theme-builder")({
  component: ThemeBuilderRoute,
})

function ThemeBuilderRoute() {
  return (
    <div className="grid gap-4 md:gap-5">
      <Card className="page-intro border-primary/10">
        <PageIntroSplitHeader
          kicker={
            <SectionKicker icon={<WandSparkles />}>Theme Builder</SectionKicker>
          }
          title="Build and share your own UI theme"
          titleClassName="text-4xl leading-none font-semibold md:text-5xl"
          description="Tune base, primary, and accent colors, then save, share, or import themes with a compact code."
          descriptionClassName="max-w-3xl text-base leading-7"
          metrics={<div className="hidden" aria-hidden />}
        />
      </Card>

      <ThemeBuilderPage />
    </div>
  )
}
